var naturalCompareWords = function naturalCompareWords(a, b) {
  return a.localeCompare(b, undefined, {
    numeric: true
  });
};
export default naturalCompareWords;